import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
import { _ as e } from "./_plugin-vue_export-helper-dad06003.js";
const i = {}, c = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function C(s, n) {
  return o(), t("svg", c, n[0] || (n[0] = [
    r("path", {
      d: "M12 7.48224V12.8265M12 15.5546V16.5178M3.49727 9.75045C5.32739 7.47738 7.39384 5.4052 9.66184 3.56879C11.0569 2.43624 12.7286 2.44401 14.1252 3.56879C16.4014 5.3972 18.4697 7.47019 20.2929 9.75045C21.3618 11.0819 21.3696 12.7488 20.2929 14.0787C18.4432 16.3734 16.3525 18.463 14.0569 20.3116C12.7488 21.3681 11.0818 21.3603 9.7737 20.3116C7.45451 18.4596 5.34933 16.3544 3.49727 14.0352C2.44705 12.7255 2.44084 11.0586 3.49727 9.75045Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const k = /* @__PURE__ */ e(i, [["render", C]]), l = {}, d = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function w(s, n) {
  return o(), t("svg", d, n[0] || (n[0] = [
    r("path", {
      d: "M3.75033 18.3333V14.1666M3.75033 5.83329V1.66663M1.66699 3.74996H5.83366M1.66699 16.25H5.83366M10.8337 2.49996L9.38851 6.25734C9.1535 6.86837 9.036 7.17388 8.85327 7.43086C8.69132 7.65862 8.49232 7.85762 8.26456 8.01957C8.00758 8.2023 7.70207 8.3198 7.09104 8.55481L3.33366 9.99996L7.09105 11.4451C7.70207 11.6801 8.00758 11.7976 8.26456 11.9804C8.49232 12.1423 8.69132 12.3413 8.85327 12.5691C9.036 12.826 9.1535 13.1315 9.38851 13.7426L10.8337 17.5L12.2788 13.7426C12.5138 13.1315 12.6313 12.826 12.8141 12.5691C12.976 12.3413 13.175 12.1423 13.4028 11.9804C13.6597 11.7976 13.9653 11.6801 14.5763 11.4451L18.3337 9.99996L14.5763 8.55481C13.9652 8.3198 13.6597 8.2023 13.4028 8.01957C13.175 7.85762 12.976 7.65862 12.8141 7.43086C12.6313 7.17388 12.5138 6.86837 12.2788 6.25734L10.8337 2.49996Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const m = /* @__PURE__ */ e(l, [["render", w]]), _ = {}, h = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function u(s, n) {
  return o(), t("svg", h, n[0] || (n[0] = [
    r("path", {
      d: "M10.0518 10.4464H10.8239C11.236 10.4464 11.6311 10.6101 11.9225 10.9015C12.2138 11.1928 12.3775 11.588 12.3775 12V16.249M10.0736 16.249H14.7032M12.3993 6.90429V7.4061M4.41081 18.7472C7.89702 22.8424 16.103 22.8424 19.5892 18.7472C22.802 14.9751 22.5581 7.59253 18.6928 4.3642C15.2299 1.47145 8.76857 1.47145 5.30722 4.3642C1.44193 7.59253 1.19802 14.9751 4.41081 18.7472Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const p = /* @__PURE__ */ e(_, [["render", u]]);
export {
  p as I,
  m as S,
  k as W
};
